var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"refreshImages":_vm._refreshImages,"loading":_vm.loading,"error":_vm.error})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }